var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVectorHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2728 12.9L13.3978 0.816642C12.9398 0.306725 12.0602 0.306725 11.6022 0.816642L0.727209 12.9C0.570677 13.0735 0.467931 13.2887 0.431463 13.5196C0.394995 13.7504 0.426376 13.9868 0.521792 14.2001C0.715126 14.6364 1.14771 14.9167 1.625 14.9167H4.04167V23.375C4.04167 23.6955 4.16897 24.0028 4.39558 24.2294C4.62219 24.456 4.92953 24.5834 5.25 24.5834H8.875C9.19547 24.5834 9.50282 24.456 9.72942 24.2294C9.95603 24.0028 10.0833 23.6955 10.0833 23.375V18.5417H14.9167V23.375C14.9167 23.6955 15.044 24.0028 15.2706 24.2294C15.4972 24.456 15.8045 24.5834 16.125 24.5834H19.75C20.0705 24.5834 20.3778 24.456 20.6044 24.2294C20.831 24.0028 20.9583 23.6955 20.9583 23.375V14.9167H23.375C23.609 14.9177 23.8383 14.8506 24.0348 14.7235C24.2313 14.5965 24.3866 14.415 24.4818 14.2012C24.577 13.9874 24.6079 13.7506 24.5708 13.5195C24.5337 13.2885 24.4301 13.0732 24.2728 12.9Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorHomeIcon);
export default __webpack_public_path__ + "static/media/VectorHomeIcon.8d86feba6a150050f8ceb40cd6447a09.svg";
export { ForwardRef as ReactComponent };